export default {
  name: 'custom-select-url',

  componentDidMount () {
    this.el.addEventListener('change', e => {
      if (this.el.value !== '') {
        if (this.props && this.props.anchors) {
          const offset = this.props.offset ? this.props.offset : 0
          const target = document.querySelector(`#${this.el.value}`)

          const bodyRect = document.body.getBoundingClientRect().top
          const elementRect = target.getBoundingClientRect().top
          const elementPosition = elementRect - bodyRect
          const offsetPosition = elementPosition - offset
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          })
        } else {
          window.open(this.el.value)
        }
      }
    })
  },
}
